import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';

import { ApprovalsReviewKind } from '../constants';
import { type ApprovalRequestReviewProps } from '../types';

export class ApprovalRequestReview extends Record<ApprovalRequestReviewProps>({
  _id: '',
  creationDate: 0,
  kind: ApprovalsReviewKind.DEFAULT,
  memberId: '',
  serviceTokenId: undefined,
  comment: '',
  workflowVersion: -1,
}) {
  getId() {
    return this._id;
  }
}

export const createApprovalRequestReview = (props: Partial<ApprovalRequestReviewProps> | ApprovalRequestReview = {}) =>
  props instanceof ApprovalRequestReview ? props : new ApprovalRequestReview(fromJS(props));
